import React, { useContext } from 'react'
import AwesomeError from 'components/Common/AwesomeError'
import BodyText from 'LuxKit/Typography/BodyText'
import ContactContext from 'contexts/contactContext'

/** @deprecated */
function CalendarRecommendationsNotAvailableMessage() {
  const contact = useContext(ContactContext)
  return (
    <AwesomeError title="No offers found for the dates you requested.">
      <BodyText variant="large" colour="neutral-one">
        But we probably have something for you.<br />
        <a
          href={`tel:${contact.defaultContact.number}`}
          rel="nofollow"
        >{contact.defaultContact.humanReadable}
        </a>.
      </BodyText>
    </AwesomeError>
  )
}

export default CalendarRecommendationsNotAvailableMessage
